import React, { Component } from "react";
import { connect } from "react-redux";
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { getRevenueBreakDown } from "../../store/actions/statements"
import { COLORS } from '../../styles/colors'

const revenueTypes = [{
  name: 'Referral memberships',
  value: 'refer'
}, {
    name: 'Workouts sold',
    value: 'workout'
}, {
    name: 'Program sold',
    value: 'program'
}]

class RevenueBreakDown extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      dataLoaded: false
    };
  }

  componentDidMount () {
      const { getRevenueBreakDown, year, month } = this.props;
      getRevenueBreakDown ({
        year,
        month
      }).then(() => {
        this.setState({
          dataLoaded: true
        })
      });
  }



  render() {

    const { breakdowns } = this.props;
    let totalAmount = 0;

    return (
      <div>
        <Dialog
          open={this.state.show}
          onClose={() => this.setState({ show: false }, () => {
              this.props.hideBreakDown();
          })}
        >
          <DialogTitle>
            View Statements
          </DialogTitle>
          <DialogContent style={{width: 500}}>
          { this.state.dataLoaded &&
          <table className="dashboard-table">
            <thead>
                <tr>
                <th>My Revenue</th>
                <th></th>
                <th style={{width:150}}>Average Collected</th>
                <th>Total</th>
                </tr>
            </thead>
            <tbody>
                { breakdowns && revenueTypes.map((revenueType, index) => {
                        const filterRevenue = Object.values(breakdowns).filter((revenue, index) => {
                            return revenue._id.type === revenueType.value
                        });
                        const revenueLength = filterRevenue.length;
                        const revenueAmount = revenueLength > 0 ? filterRevenue[0]['totalAmount'] : 0;
                        const totalRevenueCount = revenueLength > 0 ? filterRevenue[0]['totalCount'] : 0;
                        totalAmount = totalAmount + revenueAmount;
                        return (<tr key={index}>
                            <td>{revenueType.name}</td>
                            <td>{totalRevenueCount}</td>
                            <td>${ revenueLength > 0 ? (revenueAmount/totalRevenueCount).toFixed(1) : 0 }</td>
                            <td>${ revenueAmount.toFixed(1) }</td>
                        </tr>);

                  })
                }

               <tr style={{
                background: COLORS.orange,
                color: COLORS.white
                }}>
                <td>Your total</td>
                <td colSpan="2"></td>
                <td>${totalAmount.toFixed(1)}</td>
                </tr>
            </tbody>
            </table>
           }
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
    return {
        breakdowns: state.statements.breakdowns
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getRevenueBreakDown: (revenue) => {
            return dispatch(getRevenueBreakDown(revenue));
        }
    }
  }

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(RevenueBreakDown);



// WEBPACK FOOTER //
// ./src/components/settings/RevenueBreakDown.js